/**
 * Capitalizes the first letter of every word in a string.
 * Handles words separated by spaces, hyphens, or underscores.
 */
export const capitalizeWords = (str) => {
    if (!str || typeof str !== 'string') {
        return '';
    }
    return str
        .replace(/[-_]/g, ' ')
        .replace(/\b\w/g, (c) => c.toUpperCase());
};
